export default (backInStock) => ({
  options: null,
  variantData: null,
  currentVariantId: null,
  currentVariantAvailable: false,
  showBackInStock: backInStock,
  currentVariantTitle: null,
  productUrl: null,
  section: null,
  available: true,
  addToCartText: null,
  soldOutText: null,
  sizeOptionText: null,
  chooseASize: false,
  productHandle: null,
  productId: null,
  variantInventoryQuantity: null,
  variants: [],

  initVariants(variant) {
    if (!variant) this.chooseASize = true;
    this.options = Array.from(
      this.$refs.variantPicker.querySelectorAll("input:checked"),
      (select) => select.value
    );
    this.sizeOptionText = this.options[1];
    if (this.sizeOptionText === "ONESI") {
      this.sizeOptionText = "Onesize";
    }
    if (!variant) {
      this.chooseASize = true;
      return;
    }

    this.updateOptions();
  },

  updateOptions(template) {
    this.options = Array.from(
      this.$refs.variantPicker.querySelectorAll("input:checked"),
      (select) => select.value
    );
   
    this.sizeOptionText = this.options[1];
    if (this.sizeOptionText === "ONESI") {
      this.sizeOptionText = "Onesize";
    }

    this.updateMasterId();
    this.updateVariantInput();
    // Outdated: Removed updateURL() because it was causing issues with VWO and quickshop. Not needed since we save variantId in state.
    // Updated: Only update url if on PDP
    if (template === "product") {
      this.updateURL();
    }
    this.renderProductInfo();
    this.chooseASize = false;
    //this.setAvailability();
  },

  updateMasterId() {
    let variantObj = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    this.currentVariantId = variantObj.id;
    this.currentVariantAvailable = variantObj.available;
    this.currentVariantTitle = variantObj.title;
  },

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(
        this.$refs.variantPicker.querySelector('[type="application/json"]')
          .textContent
      );
    return this.variantData;
  },

  updateURL() {
    if (!this.currentVariantId) return;
    window.history.replaceState(
      {},
      "",
      `${this.productUrl}?variant=${this.currentVariantId}`
    );
  },

  renderProductInfo() {
    fetch(`${this.productUrl}?variant=${this.currentVariantId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const source = html.getElementById(`price-${this.section}`);
        const sourceQuickshop1 = html.getElementById(
          `price-qs1-${this.section}`
        );
        const sourceQuickshop2 = html.getElementById(
          `price-qs2-${this.section}`
        );
        const sourceCartNotice = html.getElementById(`cn-${this.section}`);
        const sourceAPrice = html.getElementById(`ap-${this.section}`);
        const sourceQuickshopAPrice = html.getElementsByName(
          `properties[_actualprice]`
        );

        const dest = document.getElementById(`price-${this.section}`);
        const destQuickshop1 = document.getElementById(
          `price-qs1-${this.section}`
        );
        const destQuickshop2 = document.getElementById(
          `price-qs2-${this.section}`
        );
        const destCartNotice = document.getElementById(`cn-${this.section}`);
        const destAPrice = document.getElementById(`ap-${this.section}`);
        const destQuickshopAPrice = document.getElementById(
          `ap-${this.section}`
        );

        // Update values
        if (source && dest) dest.innerHTML = source.innerHTML;
        if (sourceAPrice && destAPrice) destAPrice.value = sourceAPrice.value;
        if (sourceCartNotice && destCartNotice)
          destCartNotice.innerHTML = sourceCartNotice.innerHTML;
        if (sourceQuickshop1 && destQuickshop1)
          destQuickshop1.innerHTML = sourceQuickshop1.innerHTML;
        if (sourceQuickshop2 && destQuickshop2)
          destQuickshop2.innerHTML = sourceQuickshop1.innerHTML;

        if (sourceQuickshopAPrice && destQuickshopAPrice) {
          if (sourceQuickshopAPrice[0]) {
            destQuickshopAPrice.value = sourceQuickshopAPrice[0].value;
          }
        }

        this.updateSubmitButton();
      });
  },

  updateVariantInput() {
    const inputs = document.querySelectorAll('input[name="id"]');
    const selectedSize = document.querySelector('#selectedVariantSize');
    selectedSize.value = this.sizeOptionText; 

    for (const input of inputs) {
      input.value = this.currentVariantId;
    }
  },

  isVariantAvailable(text) {
    const variantData =
      this.variantData ||
      JSON.parse(
        this.$refs.variantPicker.querySelector('[type="application/json"]')
          .textContent
      );
    const variant = variantData.find((variant) => variant.option2 === text);
    if (variant) {
      if (variant.available) {
        return true;
      }
      return false;
    }
  },
  updateSubmitButton() {
    const button = this.$refs.submitBtnWrapper.querySelector(
      "#add-to-cart-button"
    );
    button.dataset.scrollLabel = this.currentVariantAvailable
      ? this.addToCartText
      : this.soldOutText;
    button.disabled = !this.currentVariantAvailable && !this.showBackInStock;
  },

  /*   setAvailability() {
    this.variants.forEach(
      function (arrayItem) {
        if (this.currentVariantId == arrayItem.id) {
          if (arrayItem.available) {
            this.currentVariantAvailable = arrayItem.available;
          }

          this.variantInventoryQuantity = arrayItem.quantity;
        }
      }.bind(this)
    );
  }, */
  setVariants(id, quantity, available) {
    this.variants.push({
      id: id,
      quantity: quantity,
      available: available,
    });
  },
});
